// extracted by mini-css-extract-plugin
export var actions = "_3i-0";
export var actionsContainer = "_3i-5";
export var border = "_3i-1";
export var childFullHeight = "_3i-c";
export var collapse = "_3i-2";
export var content = "_3i-7";
export var contentChild = "_3i-b";
export var fullscreen = "_3i-9";
export var headerContainer = "_3i-3";
export var hidePadding = "_3i-8";
export var noScrollX = "_3i-d";
export var noScrollY = "_3i-e";
export var optOutTopPadding = "_3i-a";
export var pagePadding = "_3i-6";
export var profile = "_3i-f";
export var profileContainer = "_3i-g";
export var profileImage = "_3i-h";
export var profileMain = "_3i-i";
export var profileSubtitle = "_3i-k";
export var profileTitle = "_3i-j";
export var tabsWrapper = "_3i-4";
export var title = "_3i-l";